import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {setJobPaymentAmount, setJobPaymentUseCustomAmount} from "./jobPaymentActions";
import UiToggle from "../../Generic/UiToggle";
import Misc from "../../../misc";


const JobPaymentPopupAdjust = (props) => {

  const {jobTotal, percentageAmount, customAmount, setJobPaymentAmount, setJobPaymentUseCustomAmount, useCustomAmount,
    paymentTotal} = props;

  const onInputChange = (event) => {
    const value = event.target.value;
    if ((useCustomAmount && !Misc.validateNumberValue(value, jobTotal))
      || (!useCustomAmount && !Misc.isValidPercent(value))) {
      return
    }
    setJobPaymentAmount(value);
  }

  return (
    <div className="job-payment__content relative job-payment__container flex flex--center flex--column">
      <p className="color-slateGray margin-t0 margin-b0 job-payment__text">
        <FormattedMessage id="paymentPopup.adjustTitle"/>
      </p>
      <UiToggle className={"margin-t16 margin-b16"} toggleItems={[
        {text: "Percent", onClick: () => setJobPaymentUseCustomAmount(false), isActive: !useCustomAmount},
        {text: "Amount", onClick: () => setJobPaymentUseCustomAmount(true), isActive: useCustomAmount},
      ]}/>
      <div className="job-payment__block flex flex--center">
        <div className="job-payment__block-item flex-item flex-item--50 margin-b16">
          <label htmlFor="paymentPercentage" className="material__label">
            <FormattedMessage id={useCustomAmount ? "paymentPopup.customAmount" : "paymentPopup.percentageAmount"}/>
          </label>
          <input className="material__input"
                 type="text"
                 placeholder=""
                 name="paymentPercentage"
                 id="paymentPercentage"
                 value={useCustomAmount ? customAmount : percentageAmount}
                 onChange={onInputChange}/>
        </div>
      </div>
      <p className="color-slateGray margin-t16 margin-b8 job-payment__text">
        <FormattedMessage id="paymentPopup.adjustTitle2"/>
      </p>
      <span className="job-payment__total">
        ${paymentTotal}
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {jobTotal, useCustomAmount, percentageAmount, customAmount, paymentTotal} = store.jobPaymentState;

  return {
    jobTotal,
    useCustomAmount,
    percentageAmount,
    customAmount,
    paymentTotal,
  };
};

const mapDispatchToProps = {
  setJobPaymentUseCustomAmount,
  setJobPaymentAmount,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupAdjust)
)
